export default __webpack_public_path__ + "static/signing2-b2660d163ba0f30482920ce176e0fb82.mp4";